import { memo } from 'react';

import type { LbPart } from '../../types';

const FreePhoto = ({ part: { data } }: { part: LbPart }) => <img src={data.imgUrl} className='lb-free-photo' />;

export default memo(FreePhoto);
